export enum CustomComesFrom {
    DELIVERED_INVOICES,
    REJECTED_INVOICES,
}
